export default __webpack_public_path__ + "static/media/SIFA_FR_SEQ10.d8808dd8.mp3";